'use client';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export interface Tab {
  key: string;
  label: string;
}

type AppTabsProps = PropsWithChildren<{
  tabs: Tab[];
  type?: 'pills' | 'underline';
  activeTabKey: string;
  onTabChange: (key: string) => void;
  full?: boolean;
  headerClass?: string;
  bodyClass?: string;
}>;

const AppTabs: React.FC<AppTabsProps> = ({
  tabs,
  type = 'pills',
  activeTabKey,
  onTabChange,
  full = false,
  headerClass = '',
  bodyClass = '',
  children,
}: AppTabsProps) => {
  return (
    <div>
      <div
        className={classNames(
          'no-scrollbar overflow-x-auto',
          type === 'pills' ? 'mb-4 rounded-2xl border border-gray-400' : '',
        )}
      >
        <ul
          className={classNames(
            'flex',
            full ? 'w-full' : '',
            headerClass,
            type === 'pills' ? 'gap-1 p-1' : '',
          )}
        >
          {tabs.map((tab) => (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li
              key={tab.key}
              className={classNames(
                type === 'pills'
                  ? 'rounded-xl py-1 text-gray-600 hover:bg-gray-50'
                  : 'border-b border-gray-200 py-padding/y-sm text-gray-800',
                full ? 'flex-1' : '',
                activeTabKey === tab.key
                  ? type === 'pills'
                    ? '!bg-primary !text-white'
                    : '!border-text/accent !text-text/accent'
                  : '',
                'min-w-auto cursor-pointer pr-4 md:min-w-75 md:pr-0 md:text-center',
              )}
              onClick={() => onTabChange(tab.key)}
            >
              <h3 className="inline whitespace-nowrap alpha-button-1">
                {tab.label}
              </h3>
            </li>
          ))}
        </ul>
      </div>

      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={bodyClass}
          style={{ display: tab.key === activeTabKey ? 'block' : 'none' }}
        >
          {children}
        </div>
      ))}
    </div>
  );
};

export default AppTabs;
